import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { COLUNAS_LANCAMENTOS, formatarValorColunaLancamento } from './lancamentosSinteticaController';
import * as C from '../../../theme/colors.constants';

/**
 * Grid "Lançamentos" da Ficha Financeira (AW2-1078) — 17 colunas fixas
 * (`COLUNAS_LANCAMENTOS`, `lancamentosSinteticaController.js`), header e
 * corpo table-driven sobre o MESMO array (mesmo padrão de
 * `TableTitulosProcesso.jsx`, nunca uma lista de `TableCell` hardcoded em
 * paralelo). Só `Data`/`Acordo` têm `TableSortLabel` (únicas 2 colunas
 * ordenáveis na tela real de produção). Sem coluna de Ações e sem toggle de
 * modo — a Sintética de produção é só leitura e não tem visão alternativa.
 *
 * `key` da linha usa o índice — mesma escolha da tela real de produção
 * (`FichaSintetica.jsx`: `<TableBodySintetica ficha={ficha} key={index} />`),
 * já que o DTO de lançamentos não expõe um id único confirmado por linha.
 */
export default function TableLancamentosSintetica({ lancamentos, ordenacao, onChangeOrdenacao }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {COLUNAS_LANCAMENTOS.map(coluna => (
            <TableCell key={coluna.campo} align={coluna.align}>
              {coluna.ordenarPor ? (
                <TableSortLabel
                  active={ordenacao.campo === coluna.ordenarPor}
                  direction={ordenacao.direcao.toLowerCase()}
                  onClick={() => onChangeOrdenacao(coluna.ordenarPor)}
                >
                  {coluna.label}
                </TableSortLabel>
              ) : coluna.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {lancamentos.map((lancamento, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={index} hover>
            {COLUNAS_LANCAMENTOS.map(coluna => (
              <TableCell key={coluna.campo} align={coluna.align}>
                {coluna.campo === 'manual'
                  ? lancamento.automatica === 'N' && <CheckCircleIcon sx={{ color: C.blackTwo }} fontSize="small" />
                  : formatarValorColunaLancamento(coluna.campo, lancamento)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

TableLancamentosSintetica.propTypes = {
  lancamentos: PropTypes.array,
  ordenacao: PropTypes.shape({
    campo: PropTypes.string,
    direcao: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  onChangeOrdenacao: PropTypes.func,
};

TableLancamentosSintetica.defaultProps = {
  lancamentos: [],
  ordenacao: { campo: 'dataLancamento', direcao: 'DESC' },
  onChangeOrdenacao: null,
};
